import { render, staticRenderFns } from "./ProgramPageContentEditor.vue?vue&type=template&id=e87ccf9e"
import script from "./ProgramPageContentEditor.vue?vue&type=script&lang=js"
export * from "./ProgramPageContentEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports